import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { ReactNode, forwardRef } from "react";
// @mui
import { Box } from "@mui/material";

interface Props {
  children?: ReactNode;
  title?: string;
  meta?: any;
}

const Page = forwardRef(
  ({ children, title = "", meta, ...other }: Props, ref: any) => (
    <>
      <Helmet>
        <title>{`${title} | SparkENC`}</title>
        {meta}
      </Helmet>

      <Box ref={ref} {...other}>
        {children}
      </Box>
    </>
  )
);

export default Page;
